class Selected {
    constructor() {
        this.selected_idx = 0
        this.players = []
        this.raw_data = []
    }

    add(player_data) {
        this.players.push(player_data)
        this.updateUrl()
    }

    remove(datum) {
        const idx = this.findIndex(datum)

        if (idx === -1) {
            return null
        }
        // slice out index
        this.players = [
            ...this.players.slice(0, idx),
            ...this.players.slice(idx + 1),
        ]

        const to_remove = this.raw_data[idx]

        // slice out raw data
        this.raw_data = [
            ...this.raw_data.slice(0, idx),
            ...this.raw_data.slice(idx + 1),
        ]

        this.updateUrl()

        return to_remove
    }

    includes({ entity_id, start_year, key_team_id }) {
        return Boolean(
            this.players.filter(
                (d) =>
                    d.entity_id === entity_id &&
                    d.start_year === start_year &&
                    d.key_team_id === key_team_id
            ).length
        )
    }

    findIndex({ entity_id, start_year, key_team_id }) {
        return this.players.findIndex(
            (d) =>
                d.entity_id === entity_id &&
                d.start_year === start_year &&
                d.key_team_id === key_team_id
        )
    }

    // Match the index regardless of what order our fetched data returns
    addRawData(data) {
        const index = this.findIndex(data.row)

        this.raw_data[index] = data
    }

    // removeRawData({ entity_id, start_year, key_team_id }) {
    //     const to_remove = this.raw_data.filter((d) => d.player_id === player_id)
    //     this.raw_data = this.raw_data.filter((d) => d.player_id !== player_id)

    //     return to_remove
    // }

    selected() {
        return this.raw_data[this.selected_idx]
    }

    setSelectedIdx(idx) {
        this.selected_idx = idx
        this.updateUrl()
    }

    incrementSelectedIdx(inc) {
        this.selected_idx += inc
        this.updateUrl()
    }

    updateUrl() {
        // Only handle the visual parts of the url
        const keys = this.players.map(
            (d) => `${d.entity_id}-${d.start_year}-${d.key_team_id}`
        )

        // Get object of url search parameters
        const urlParams = new URLSearchParams(window.location.search)

        urlParams.set('players', keys.join(','))
        urlParams.set('selected_idx', this.selected_idx)

        const url = `${window.location.pathname}?${urlParams.toString()}`
        window.history.replaceState('', '', url)
    }
}

const selected = new Selected()

export default selected
